var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteSmsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9216 18.6668H8.07849C5.72555 18.6668 4.15692 17.4904 4.15692 14.7453V9.25506C4.15692 6.50997 5.72555 5.3335 8.07849 5.3335H15.9216C18.2746 5.3335 19.8432 6.50997 19.8432 9.25506V14.7453C19.8432 17.4904 18.2746 18.6668 15.9216 18.6668Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.04575,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9216 9.64697L13.4667 11.6078C12.6588 12.2509 11.3333 12.2509 10.5255 11.6078L8.07843 9.64697",
    stroke: "#CB9C2D",
    strokeWidth: 1.04575,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSmsIcon);
export default __webpack_public_path__ + "static/media/whiteSmsIcon.9cd1847028af939f1cd113f8b30a4974.svg";
export { ForwardRef as ReactComponent };